import { createI18n } from 'vue-i18n';

import en from './lang/en.json';
import es from './lang/es.json';

import zEn from './lang/zrater/en';
import zEs from './lang/zrater/es';
import enDescriptions from './lang/zrater/enDescriptions';
import esDescriptions from './lang/zrater/esDescriptions';

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency' as const,
      currency: 'USD',
      notation: 'standard' as const,
    },
    decimal: {
      style: 'decimal' as const,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent' as const,
      useGrouping: false,
    },
  },
  'es-US': {
    currency: {
      style: 'currency' as const,
      currency: 'USD',
      notation: 'standard' as const,
    },
    decimal: {
      style: 'decimal' as const,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent' as const,
      useGrouping: false,
    },
  },
};
type MessageSchema = typeof en;
type MessageSchemaEs = typeof es;

const i18n = createI18n<[MessageSchema | MessageSchemaEs], 'en-US' | 'es-US'>({
  // legacy: false,
  // globalInjection: false,
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US', // set fallback locale
  messages: {
    'en-US': { ...en, ...zEn, ...enDescriptions },
    'es-US': { ...es, ...zEs, ...esDescriptions },
  },
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  numberFormats,
});
export default i18n;
